export default __webpack_public_path__ + "static/media/rent.d3d96df3.png";